/* ============ OSO store, cart / wishlist / orders state (localStorage) ============
   Loaded on EVERY page, after oso-products.js, before oso-chrome.js.
   Emits window 'oso:store' whenever anything changes (chrome badges + pages listen). */
(function(){
  const CART='oso_cart_v1', WISH='oso_wish_v1', ORDERS='oso_orders_v1', USER='oso_user_v1';
  const read =k=>{try{return JSON.parse(localStorage.getItem(k))||[]}catch(e){return[]}};
  const readO=k=>{try{return JSON.parse(localStorage.getItem(k))||null}catch(e){return null}};
  const save =(k,v)=>{localStorage.setItem(k,JSON.stringify(v));window.dispatchEvent(new CustomEvent('oso:store'));};
  const keyOf=i=>`${i.id}|${i.color}|${i.size}`;
  const priceOf=id=>{const p=window.OSO_findProduct?OSO_findProduct(id):null;return p?p.price:1900;};

  const S={
    keyOf, priceOf,
    /* ---- cart ---- */
    getCart:()=>read(CART),
    addToCart(id,color,cn,size,qty=1){
      const cart=read(CART), k=`${id}|${color}|${size}`, ex=cart.find(i=>keyOf(i)===k);
      if(ex) ex.qty+=qty; else cart.push({id,color,cn,size,qty});
      save(CART,cart); window.dispatchEvent(new CustomEvent('oso:added'));
    },
    setQty(k,qty){const cart=read(CART),i=cart.find(x=>keyOf(x)===k);if(!i)return;i.qty=Math.max(1,qty|0);save(CART,cart);},
    removeFromCart(k){save(CART,read(CART).filter(x=>keyOf(x)!==k)); S.toast('Removed from bag');},
    clearCart(){save(CART,[]);},
    cartCount:()=>read(CART).reduce((n,i)=>n+i.qty,0),
    cartSubtotal:()=>read(CART).reduce((s,i)=>s+priceOf(i.id)*i.qty,0),
    /* bundle: buy any 3+ tees, ₹500 off */
    bundleDiscount(){return S.cartCount()>=3?500:0;},
    shipping(){const sub=S.cartSubtotal()-S.bundleDiscount();return sub===0||sub>=1900?0:99;},
    cartTotal(){return Math.max(0,S.cartSubtotal()-S.bundleDiscount())+S.shipping();},
    /* ---- wishlist, saved per colourway, stored as "id|hex" ---- */
    getWishlist:()=>read(WISH),
    /* [{id,color,cn}] ready to render */
    wishlistItems(){return read(WISH).map(k=>{const [id,color]=String(k).split('|');
      const p=window.OSO_findProduct?OSO_findProduct(id):null;
      const hex=color||(p?p.color:'');
      return {key:k,id,color:hex,cn:window.OSO_colorName?OSO_colorName(hex):''};});},
    wishKey(id,color){const p=window.OSO_findProduct?OSO_findProduct(id):null;
      return id+'|'+(color||(p?p.color:''));},
    toggleWishlist(id,color){let w=read(WISH); const k=S.wishKey(id,color);
      if(w.includes(k)){w=w.filter(x=>x!==k);save(WISH,w);S.toast('Removed from wishlist');return false;}
      w.push(k);save(WISH,w);S.toast('Saved to wishlist','heart');return true;},
    removeFromWishlist(key){save(WISH,read(WISH).filter(x=>x!==key));},
    /* no colour given → true if any colourway of this product is saved */
    inWishlist(id,color){const w=read(WISH);
      return color?w.includes(S.wishKey(id,color)):w.some(x=>String(x).split('|')[0]===id);},
    wishlistCount:()=>read(WISH).length,
    /* ---- orders ---- */
    getOrders:()=>read(ORDERS),
    placeOrder(details){
      const items=read(CART); if(!items.length) return null;
      const d=new Date();
      const order={id:'OSO-'+d.getFullYear()+String(d.getMonth()+1).padStart(2,'0')+String(d.getDate()).padStart(2,'0')+'-'+Math.floor(1000+Math.random()*9000),
        date:d.toISOString(), items, subtotal:S.cartSubtotal(), discount:S.bundleDiscount(), shipping:S.shipping(), total:S.cartTotal(), ...details};
      const all=read(ORDERS); all.unshift(order); save(ORDERS,all); save(CART,[]); return order;
    },
    /* ---- user (mock auth) ---- */
    getUser:()=>readO(USER),
    signIn(name,email){localStorage.setItem(USER,JSON.stringify({name,email}));window.dispatchEvent(new CustomEvent('oso:store'));},
    signOut(){localStorage.removeItem(USER);window.dispatchEvent(new CustomEvent('oso:store'));},
    /* ---- toast ---- */
    toast(msg,icon){
      let host=document.getElementById('osoToastHost');
      if(!host){host=document.createElement('div');host.id='osoToastHost';document.body.appendChild(host);
        document.head.appendChild(Object.assign(document.createElement('style'),{textContent:`
#osoToastHost{position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:1000;display:flex;flex-direction:column;gap:10px;align-items:center;pointer-events:none}
.oso-toast{display:flex;align-items:center;gap:10px;background:#17150f;color:#eae8df;font-family:"Funnel Sans",Arial,sans-serif;font-size:14px;font-weight:600;padding:13px 20px;border-radius:40px;box-shadow:0 16px 40px rgba(20,16,36,.38);opacity:0;transform:translateY(14px) scale(.96)}
.oso-toast svg{width:17px;height:17px;fill:none;stroke:#eae8df;stroke-width:2}
.oso-toast .dot{width:8px;height:8px;border-radius:50%;background:#eae8df}`}));}
      const icons={bag:'<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
                   heart:'<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-7-10a3.8 3.8 0 0 1 7-1.6A3.8 3.8 0 0 1 19 10c0 5.4-7 10-7 10Z"/></svg>'};
      const t=document.createElement('div'); t.className='oso-toast';
      t.innerHTML=(icons[icon]||'<span class="dot"></span>')+`<span>${msg}</span>`;
      host.appendChild(t);
      if(window.gsap){gsap.to(t,{opacity:1,y:0,scale:1,duration:.4,ease:'back.out(1.6)'});
        gsap.to(t,{opacity:0,y:-10,duration:.4,delay:1.9,ease:'power2.in',onComplete:()=>t.remove()});}
      else{t.style.opacity=1;t.style.transform='none';setTimeout(()=>t.remove(),2200);}
    }
  };
  window.OSO_STORE=S;
})();
